import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import './App.css';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from 'react-router-dom';

import HasKnownFault from './Pages/HasKnownFault';
import KnownFault from './Pages/KnownFault';
import HasCancer from './Pages/HasCancer';
import WithCancerType from './Pages/WithCancerType';
import WithBreastCancer from './Pages/WithBreastCancer';
import WithOvarianCancer from './Pages/WithOvarianCancer';
import WithBowelCancer from './Pages/WithBowelCancer';
import WithProstateCancer from './Pages/WithProstateCancer';
import WithEndometrialCancer from './Pages/WithEndometrialCancer';

import UnaffectedCancerType from './Pages/UnaffectedCancerType';
import UnaffectedBreastCancer from './Pages/UnaffectedBreastCancer';
import UnaffectedBreastCancerExclusively from './Pages/UnaffectedBreastCancerExclusively';
import UnaffectedBreastAndOvarianCancer from './Pages/UnaffectedBreastAndOvarianCancer';
import UnaffectedOvarianCancer from './Pages/UnaffectedOvarianCancer';
import UnaffectedBowelCancer from './Pages/UnaffectedBowelCancer';
import UnaffectedProstateCancer from './Pages/UnaffectedProstateCancer';
import UnaffectedEndometrialCancer from './Pages/UnaffectedEndometrialCancer';

function App() {
  return (
    <Router>
        <Switch>
            <Route path="/known-fault">
                <KnownFault />
            </Route>
            <Route path="/no-gene-fault">
                <HasCancer />
            </Route>
            <Route path="/affected/breast">
                <WithBreastCancer />
            </Route>
            <Route path="/affected/breast">
                <WithBreastCancer />
            </Route>
            <Route path="/affected/breast">
                <WithBreastCancer />
            </Route>
            <Route path="/affected/ovarian">
                <WithOvarianCancer />
            </Route>
            <Route path="/affected/bowel">
                <WithBowelCancer />
            </Route>
            <Route path="/affected/prostate">
                <WithProstateCancer />
            </Route>
            <Route path="/affected/endometrial">
                <WithEndometrialCancer />
            </Route>
            <Route path="/affected">
                <WithCancerType />
            </Route>
            <Route path="/unaffected/breast/exclusive">
                <UnaffectedBreastCancerExclusively />
            </Route>>
            <Route path="/unaffected/breast/breast-and-ovarian">
                <UnaffectedBreastAndOvarianCancer />
            </Route>
            <Route path="/unaffected/breast">
                <UnaffectedBreastCancer />
            </Route>
            <Route path="/unaffected/ovarian">
                <UnaffectedOvarianCancer />
            </Route>
            <Route path="/unaffected/bowel">
                <UnaffectedBowelCancer />
            </Route>
            <Route path="/unaffected/prostate">
                <UnaffectedProstateCancer />
            </Route>
            <Route path="/unaffected/endometrial">
                <UnaffectedEndometrialCancer />
            </Route>
            <Route path="/unaffected">
                <UnaffectedCancerType />
            </Route>
            <Route path="/">
                <HasKnownFault />
            </Route>
        </Switch>
    </Router>
  );
}

export default App;
